import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';
import { ChannelFeatures, FeatureFlagMap, FeatureFlagState, FeatureFlagsEnum } from './types';

export const reducers = (create: ReducerCreators<FeatureFlagState>) => ({
  setFeatureFlags: create.reducer((state, action: PayloadAction<FeatureFlagMap>) => {
    state.featureFlags = action.payload;
  }),
  setChannelFeatures: create.reducer((state, action: PayloadAction<ChannelFeatures>) => {
    state.channelFeatures = action.payload;
  }),
  toggleFeatureFlag: create.reducer((state, action: PayloadAction<FeatureFlagsEnum>) => {
    state.featureFlags[action.payload] = !state.featureFlags[action.payload];
  }),
});
